module.exports = __webpack_public_path__ + "img/arrowIcon.e03c99e6.png";